import { render } from "./UserAvatarImg.vue?vue&type=template&id=23a82961"
import script from "./UserAvatarImg.vue?vue&type=script&lang=js"
export * from "./UserAvatarImg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__